import React from 'react';
import PersonTrackRecords from 'containers/pages/persons/PersonTrackRecords';

const PersonInputDataTab = () => {
  return <PersonTrackRecords />;
};

export default PersonInputDataTab;
